export enum HandleId {
    Global = "a",
    OutputFlow = "outputFlow",
    Input = "input",
    OutputHandle = "outputHandle",
    ConditionHandle = "conditionHandle",
}

export type HandleColor = {
    background: string;
    color: string;
};

export type HandleSide = "left" | "right";

export type InputHandleProps = {
    index: number;
    colorActive?: HandleColor;
};

export type OutputHandleProps = {
    isActive: boolean;
    colorActive?: HandleColor;
    handleId?: HandleId;
    style?: React.CSSProperties;
};

export type UseHandleConnectionProps = {
    handleId: HandleId;
    validSourceHandles: HandleId[];
    isActive?: boolean;
    colorActive?: HandleColor;
    side: HandleSide;
};
